import React from 'react';
import { NavItem, Nav } from 'react-bootstrap';
import { Button } from '../../../form/FormControls.jsx';

export const LinkHeader = (props) =>
  <div className="second-nav-bar deal-header">
    <Nav pullLeft className="deal-buttons">
      <NavItem className={'selected-deal'}>
        <span
          className={'transition-deal-button'}
        >
          {props.caption}
        </span>
      </NavItem>
    </Nav>
    <Nav pullRight bsStyle="pills" className="navbar-always-float">
      <div className={'deal-filters'}>
        <NavItem>
          <Button
            style={{
              marginRight: 7,
            }}
            className="deal-actions"
            id="link_back"
            onClick={props.stepBack}
          >
          Back
          </Button>
          <Button
            bsStyle="primary"
            onClick={props.stepForward}
            disabled={props.disabled}
            id="link_save"
            className="deal-actions"
            style={{
              width: 71,
            }}
          >
          Link
          </Button>
        </NavItem>
      </div>
    </Nav>
  </div>;

LinkHeader.propTypes = {
  caption: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  stepForward: React.PropTypes.func,
  stepBack: React.PropTypes.func,
};
